
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 95.12 71.34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4fa2b7"}},[_c('path',{attrs:{"d":"M66.47 16.65l8.26-8.26a32.14 32.14 0 00-7.18-4.91l-9 9a16.87 16.87 0 017.92 4.17zM72.23 28.7l9.57-9.57a1.55 1.55 0 01.48-.32 30.79 30.79 0 00-5.19-8l-8.44 8.43a22.87 22.87 0 013.58 9.46z"}}),_c('path',{attrs:{"d":"M84.72 28.83A29.84 29.84 0 0083.46 22L72.6 32.85a25 25 0 01-.1 3.23s10.73 2.49 10.73 12c0 6.23-5.41 11.39-12.21 11.39H24.11c-6.8 0-12.22-5.17-12.22-11.39 0-4.41 4.12-10.52 11-12.07-3.4-16.17 12-14.19 12-14.19a21.42 21.42 0 0117.92-9.91h1.58l9.9-9.89A33 33 0 0052.76 0C42.65 0 33.29 5.05 29.27 10.07A21.34 21.34 0 0010.4 28.85C6.54 30.32 0 38.85 0 48.06 0 61 10.86 71.34 24.11 71.34H71c13.25 0 24.1-10.36 24.1-23.28.02-9.18-6.22-17.14-10.38-19.23z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/logos/cloud.svg